import setLocalStorage from './set-local-storage';

export { setLocalStorage };

export default setLocalStorage;
